#== Description
# This widget allows styling changes on progressbar items by toggling a class
# when tabbing through them.
#
#== Behaviour
# On enabled progressbar items:
# - on focus, finds the closest li of the current anchor & adds class "focus"
# - on blur, finds the closest li of the current anchor & removes class "focus"

require('bijou/base')

"use strict"

$.widget "chopin.progressbar", $.bijou.base,

  _create: ->
    @_on
      "focus a": (e) ->
        $(e.currentTarget).closest("li").addClass("focus")

      "blur a": (e) ->
        $(e.currentTarget).closest("li").removeClass("focus")
